import * as React from 'react'
import clx from 'classnames'

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  colorClass?: string
  className?: string
}

export const SimpleSpinner = ({
  size = 'sm',
  colorClass = 'border-content-primary',
  className,
}: SpinnerProps) => {
  const sizeClasses = {
    sm: 'tw-w-4 tw-h-4 tw-border-2',
    md: 'tw-w-6 tw-h-6 tw-border-4',
    lg: 'tw-w-10 tw-h-10 tw-border-[6px]',
  }

  return (
    <div
      className={clx(
        'tw-animate-spin tw-rounded-full tw-border-t-transparent',
        sizeClasses[size],
        colorClass,
        className,
      )}
    />
  )
}
